
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import CustomerFundingService from '@/services/customerFunding.service';

@Component({})
export default class VisitDetailListModal extends Vue {
  visible = false;

  title = '通话记录';

  @lazyInject(CustomerFundingService)
  private customerFundingService!: CustomerFundingService;

  @Prop({ type: String, default: 'ordinary' })
  type!: string;

  record: any;

  timeline: any[] = [];

  visitDetail: any = [];

  async init(record: any) {
    this.visitDetail = record.visit_detail || [];
    this.visible = true;
  }

  handleCancel() {
    this.visible = false;
  }

  formatSeconds(seconds: number): string {
    if (seconds < 0) {
      throw new Error('秒数不能为负数');
    }

    if (seconds < 60) {
      return `${seconds}秒`;
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = String(seconds % 60).padStart(2, '0');

    return `${minutes}分${remainingSeconds}秒`;
  }
}

